 const apiUrl = "https://rue-backend.unicotaxi.com";
 const fileUrl = "";
 const profileimageUrl = "";

export const CUSTOM_CONSTANTS = {
  API_BASE_URL: apiUrl,
  BASE_CURRENCY : '\u00A3', 
};

export const API_ENDPOINTS = {
// Image URL
FILE_URL: fileUrl,

// active endpoints

// GMAP ENDPOINTS
GMAP_API:'AIzaSyDd66Ag8p05G1rJGHI4J8kQ-yi3sNV7yqw',

// upload endpoints
MULTI_IMAGE_FILE_UPLOAD: `${apiUrl}/api/uploads/multiple`,
SINGLE_IMAGE_FILE_UPLOAD: `${apiUrl}/api/uploads/single`,
SITE_IMAGE_UPLOAD:`${apiUrl}/api/settings/siteimageupload`,
IMAGE_UPLOAD_SINGLE: `${apiUrl}/uploads/single`,
MULTI_FILE_UPLOAD: `${apiUrl}/api/uploads/file/multiple`,
SINGLE_FILE_UPLOAD: `${apiUrl}/api/uploads/file/single`,

// Login
LOGIN: `${apiUrl}/api/user/login`,
PROFILE_IMAGE_UPLOAD:`${apiUrl}/api/user`,

// Profile
PROFILE: `${apiUrl}/api/user/auth-user-admin`,
UPDATE_PROFILE: `${apiUrl}/api/user`,
UPDATE_PASSWORD: `${apiUrl}/api/user/change-password`,
GET_USER_DETAILS: `${apiUrl}/api/user/auth-token`,
UPDATE_USER_PASSWORD: `${apiUrl}/api/user/change-password`,

//Service fare type
GET_CREATED_FARE_LIST: `${apiUrl}/api/service-fare/fare-created-service`,
GET_EXCLUDED_FARE_LIST: `${apiUrl}/api/service-fare/fare-excluded-service`,
ADD_SERVICE_FARE: `${apiUrl}/api/service-fare`,
GET_SERVICE_FARE_DETAILS_BY_ID: `${apiUrl}/api/service-fare`,
UPDATE_SERVICE_FARE_DETAILS_BY_ID: `${apiUrl}/api/service-fare`,
DELETE_SERVICE_FARE_BY_ID: `${apiUrl}/api/service-fare`,

//Zone type Service fare 
GET_CREATED_ZONEFARE_LIST: `${apiUrl}/api/zone-fare/fare-created-service`,
GET_EXCLUDED_ZONEFARE_LIST: `${apiUrl}/api/zone-fare/fare-excluded-service`,
ADD_ZONE_FARE: `${apiUrl}/api/zone-fare`,
GET_ZONE_FARE_DETAILS_BY_ID: `${apiUrl}/api/zone-fare`,
UPDATE_ZONE_FARE_DETAILS_BY_ID: `${apiUrl}/api/zone-fare`,
DELETE_ZONE_FARE_BY_ID: `${apiUrl}/api/zone-fare`,

//Ratings
GET_USERRATINGS_LIST:`${apiUrl}/api/user-ratings`,
GET_DRIVERRATINGS_LIST:`${apiUrl}/api/driver-ratings`,

// Dashboard
DASHBOARD: `${apiUrl}/api/dashboard`,

// Members
MEMBER: `${apiUrl}/member/list`,
UPDATE_ADMIN: `${apiUrl}/update-user-admin/:id`,
UPDATE_USER: `${apiUrl}/update-user-web/:id`,
ADD_MEMBER: `${apiUrl}/register`,
GET_MEMBER_BY_ID: `${apiUrl}/:type/:id`,
GET_LIST_COUNTS: `${apiUrl}/home`,


// Settings
UPDATE_APP_STATE: `${apiUrl}/settings/app-enbd`,
UPDATE_SMS_STATE: `${apiUrl}/settings/sms-enbd`,
GET_MASTER_VALUES: `${apiUrl}/settings`,
UPDATE_MASTER_VALUES: `${apiUrl}/settings/google-key-nd-pv`,
UPDATE_SITE_SETTIGNS: `${apiUrl}/api/settings`,
GET_SITE_SETTINGS: `${apiUrl}/api/settings`,
UPDATE_SITE_SETTINGS: `${apiUrl}/api/settings`,
GET_PAYMENT_SETTINGS: `${apiUrl}/api/settings/payment`,
UPDATE_PAYMENT_SETTINGS: `${apiUrl}/api/settings/payment`,
GET_PLATFORM_SETTINGS: `${apiUrl}/api/settings/platform`,
UPDATE_PLATFORM_SETTINGS: `${apiUrl}/api/settings/platform`,
GET_USER_REWARD_SETTINGS: `${apiUrl}/api/settings/userrewards`,
UPDATE_USER_REWARD_SETTINGS: `${apiUrl}/api/settings/userrewards`,
GET_BUSINESS_SETTINGS: `${apiUrl}/api/settings/business`,
UPDATE_BUSINESS_SETTINGS: `${apiUrl}/api/settings/business`,
GET_LEGAL_SETTINGS: `${apiUrl}/api/settings/legal`,
UPDATE_LEGAL_SETTINGS: `${apiUrl}/api/settings/legal`,
GET_PRIVACY_SETTINGS: `${apiUrl}/api/settings/privacy`,
UPDATE_PRIVACY_SETTINGS: `${apiUrl}/api/settings/privacy`,
ADD_Banks: `${apiUrl}/api/settings/banks`,
GET_BANKS_LIST: `${apiUrl}/api/settings/banks`,
GET_BANK_DETAILS_BY_ID: `${apiUrl}/api/settings/banks`,
UPDATE_BANK_DETAILS_BY_ID:`${apiUrl}/api/settings/banks`, 
DELETE_BANK_DETAILS_BY_ID:`${apiUrl}/api/settings/banks`, 
ADD_Banks_ACC: `${apiUrl}/api/settings/banksacc`,
GET_BANKS_LIST_ACC: `${apiUrl}/api/settings/banksacc`,
GET_BANK_DETAILS_BY_ID_ACC: `${apiUrl}/api/settings/banksacc`,
UPDATE_BANK_DETAILS_BY_ID_ACC:`${apiUrl}/api/settings/banksacc`, 
DELETE_BANK_DETAILS_BY_ID_ACC:`${apiUrl}/api/settings/banksacc`, 

//Location
GET_SERVICE_AREA: `${apiUrl}/api/service-area`,
GET_SERVICE_AREA_BY_ID: `${apiUrl}/api/service-area`,
ADD_SERVICE_AREA: `${apiUrl}/api/service-area`,
UPDATE_SERVICE_AREA: `${apiUrl}/api/service-area`,
DELETE_SERVICE_AREA: `${apiUrl}/api/service-area`,

GET_RESTRICTED_SERVICE_AREA: `${apiUrl}/api/service-restricted-areas`,
GET_RESTRICTED_SERVICE_AREA_BY_ID: `${apiUrl}/api/service-restricted-areas/:id`,
ADD_RESTRICT_SERVICE_AREA: `${apiUrl}/api/service-restricted-areas`,
UPDATE_RESTRICT_SERVICE_AREA: `${apiUrl}/api/service-restricted-areas`,
GET_RESTRICTED_DETAILS_BY_ID: `${apiUrl}/api/service-restricted-areas`,
DELETE_RESTRICTED_DETAILS_BY_ID: `${apiUrl}/api/service-restricted-areas`,

//Passengers
GET_CUSTOMERS_LIST: `${apiUrl}/api/customer`,
GET_CUSTOMER_DETAILS_BY_ID: `${apiUrl}/api/customer`,
DELETE_CUSTOMER_DETAILS_BY_ID: `${apiUrl}/api/customer`,
UPDATE_CUSTOMER_DETAILS_BY_ID: `${apiUrl}/api/customer`,
ADD_PASSENGERS: `${apiUrl}/api/customer/register`,
GET_SERVICE_LIST: `${apiUrl}/api/service`,
GET_PASSENGER_REQUEST_HISTORY: `${apiUrl}/api/customer/user-trips`,
GET_PASSENGER_REQUEST_HISTORY_BYID: `${apiUrl}/api/customer/user-trip`,
GET_PASSENGER_TRIP_HISTORY_BYID: `${apiUrl}/api/customer/trip-history`,
DELETE_PASSENGER_REQUEST_BYID: `${apiUrl}/api/customer/delete-user-trip`,

//Promocode
ADD_PROMOCODE: `${apiUrl}/api/promocode/add`,
GET_PROMOCODE_LIST: `${apiUrl}/api/promocode`,
GET_PROMOCODE_DETAILS_BY_ID: `${apiUrl}/api/promocode`,
UPDATE_PROMOCODE_DETAILS_BY_ID: `${apiUrl}/api/promocode`,
DELETE_PROMOCODE_DETAILS_BY_ID: `${apiUrl}/api/promocode`,

//Drivers
ADD_DRIVER: `${apiUrl}/api/driver/web-register`,
UPDATE_DRIVER: `${apiUrl}/api/driver`,
CREATE_DRIVER_RIDE: `${apiUrl}/api/driver`,
DELETE_DRIVER: `${apiUrl}/api/driver/delete-driver-web`,
UPDATE_DRIVER_RIDE: `${apiUrl}/api/driver`,
UPLOAD_VEHICLE_IMAGE: `${apiUrl}/api/driver/service/vehicleimage`,
GET_DRIVER_SERVICE_DETAILS: `${apiUrl}/api/driver/service`,
UPDATE_DRIVER_SERVICE_STATUS: `${apiUrl}/api/driver/service/status`,
DRIVER_ENDPOINT: `${apiUrl}/api/user`,
GET_DRIVER_BANK_DETAILS_BY_ID: `${apiUrl}/api/settings/banks/getdriver`,
UPDATE_DRIVER_BANK_DETAILS_BY_ID: `${apiUrl}/api/settings/banks/updatedriver`,
GET_DRIVER_DOCUMENTS_BY_DRIVER_ID: `${apiUrl}/api/driver-document/driver`,
DRIVER_DOCUMENT_END_POINT: `${apiUrl}/api/driver-document`,
UPDATE_DRIVER_DOCUMENT_END_POINT: `${apiUrl}/api/driver/driversdoc`,
DELETE_DRIVER_DOCUMENT_END_POINT: `${apiUrl}/api/driver/driversdoc`,
DRIVER_DOCUMENT_UPDATE: `${apiUrl}/api/driver-document/status`,
DRIVER_COMPLETE_DETAILS: `${apiUrl}/api/driver/complete`,
GET_DRIVER_USER: `${apiUrl}/api/driver`,
GET_ALL_DRIVER_EARNINGS_LIST: `${apiUrl}/api/driver-earnings`,
GET_A_DRIVER_EARNINGS_LIST: `${apiUrl}/api/driver-earnings/earning-logs`,
GET_ALL_DRIVER_REWARDS_LIST: `${apiUrl}/api/driver-earnings/rewards`,
GET_A_DRIVER_REWARDS_LIST: `${apiUrl}/api/driver-earnings/reward-logs`,
GET_A_DRIVERS_CASHOUTRECORDS: `${apiUrl}/api/driver-earnings/cashoutrecords`,
UPDATE_A_DRIVERS_CASHOUTRECORDS: `${apiUrl}/api/driver-earnings/update-cashoutrecords`,
GET_A_DRIVERS_CASHOUTSHEETS: `${apiUrl}/api/driver-earnings/cashoutsheets`,
UPDATE_A_DRIVERS_CASHOUTSHEETS: `${apiUrl}/api/driver-earnings/update-cashoutsheets`,

//Service type
GET_SERVICES: `${apiUrl}/api/service`,
ADD_SERVICES: `${apiUrl}/api/service`,
GET_SERVICES_WITH_FARE_MODEL: `${apiUrl}/api/service/withfaremodel`,
GET_SERVICE_DETAILS_BY_ID: `${apiUrl}/api/service`,
UPDATE_SERVICE_DETAILS_BY_ID: `${apiUrl}/api/service`,
DELETE_SERVICE_BY_ID: `${apiUrl}/api/service`,

//banner template
GET_BANNERS_LIST: `${apiUrl}/api/Banner`,
GET_BANNERS_DETAILS_BY_ID: `${apiUrl}/api/Banner`,
ADD_BANNERS: `${apiUrl}/api/Banner`,
UPDATE_BANNERS_DETAILS_BY_ID :`${apiUrl}/api/Banner`,
DELETE_BANNERS_BY_ID: `${apiUrl}/api/Banner`,

//Dispatcher
GET_ALL_DISPATCHERS:`${apiUrl}/api/dispatcher`,
GET_DISPATCHER_DETAILS_BY_ID: `${apiUrl}/api/dispatcher`,
UPDATE_DISPATCHER_DETAILS_BY_ID: `${apiUrl}/api/dispatcher`,
DELETE_DISPATCHER_DETAILS_BY_ID: `${apiUrl}/api/dispatcher`,
ADD_DISPATCHER: `${apiUrl}/api/dispatcher/register`,
GET_DRIVERS_AND_SERVICES: `${apiUrl}/api/dispatcher/services_drivers`,
GET_SELECTED_SERVICE_DRIVERS: `${apiUrl}/api/dispatcher/selected_service_drivers`,
GET_SELECTED_RIDE_STATUS_DRIVERS: `${apiUrl}/api/dispatcher/selected_status_drivers`,
CREATE_NEW_RIDE_BY_DISPATCHER:`${apiUrl}/api/dispatcher/create-trip`,
ASSIGN_NEW_RIDE_BY_DISPATCHER:`${apiUrl}/api/dispatcher/assign-trip`,
FETCH_NEARBY_DRIVERS:`${apiUrl}/api/dispatcher/nearbydrivers`,
CANCEL_RIDE_BY_DISPATCHER_OR_ADMIN:`${apiUrl}/api/user-trips/cancelride`,
DISPATCH_RIDE_BY_DISPATCHER_OR_ADMIN:`${apiUrl}/api/user-trips/dispatchride`,
CANCEL_DISPATCH_BY_DISPATCHER_OR_ADMIN:`${apiUrl}/api/dispatcher/cancel-dispatch`,

//Accountmanager
GET_ALL_MANAGERS:`${apiUrl}/api/account-manager`,
GET_MANAGER_DETAILS_BY_ID: `${apiUrl}/api/account-manager`,
UPDATE_MANAGAER_DETAILS_BY_ID: `${apiUrl}/api/account-manager`,
DELETE_MANAGER_DETAILS_BY_ID: `${apiUrl}/api/account-manager`,
ADD_MANAGER: `${apiUrl}/api/account-manager/register`,

//Subcompany
GET_ALL_SUBCOMPANY:`${apiUrl}/api/sub-company`,
GET_ALL_SUBCOMPANY_NAMES:`${apiUrl}/api/sub-company/names`,
GET_SUBCOMPANY_DETAILS_BY_ID: `${apiUrl}/api/sub-company`,
UPDATE_SUBCOMPANY_DETAILS_BY_ID: `${apiUrl}/api/sub-company`,
DELETE_SUBCOMPANY_DETAILS_BY_ID: `${apiUrl}/api/sub-company`,
ADD_SUBCOMPANY: `${apiUrl}/api/sub-company/register`,

//Corporate
GET_CORPORATE: `${apiUrl}/api/user/corporate`,
GET_ALL_CORPORATE:`${apiUrl}/api/corporate`,
GET_CORPORATE_DETAILS_BY_ID: `${apiUrl}/api/corporate`,
UPDATE_CORPORATE_DETAILS_BY_ID: `${apiUrl}/api/corporate`,
DELETE_CORPORATE_DETAILS_BY_ID: `${apiUrl}/api/corporate`,
ADD_CORPORATE: `${apiUrl}/api/corporate/register`,
ADD_GROUPS: `${apiUrl}/api/corporate/add_group`,
GET_CORPORATE_GRP:`${apiUrl}/api/corporate/grp`,
GET_CORPORATE_GRP_DETAILS_BY_ID: `${apiUrl}/api/corporate/grp`,
UPDATE_CORPORATE_GRP_DETAILS_BY_ID: `${apiUrl}/api/corporate/grp`,
DELETE_CORPORATE_GRP_DETAILS_BY_ID: `${apiUrl}/api/corporate/grp`,
ADD_EMPLOYEES: `${apiUrl}/api/corporate/add_employee`,
GET_CORPORATE_EMPLOYEES:`${apiUrl}/api/corporate/emp`,
GET_CORPORATE_EMPLOYEES_DETAILS_BY_ID: `${apiUrl}/api/corporate/emp`,
UPDATE_CORPORATE_EMPLOYEES_DETAILS_BY_ID: `${apiUrl}/api/corporate/emp`,
DELETE_CORPORATE_EMPLOYEES_DETAILS_BY_ID: `${apiUrl}/api/corporate/emp`,

//Hotel
GET_ALL_HOTELS:`${apiUrl}/api/hotel`,
GET_HOTELS_DETAILS_BY_ID: `${apiUrl}/api/hotel`,
UPDATE_HOTELS_DETAILS_BY_ID: `${apiUrl}/api/hotel`,
DELETE_HOTELS_DETAILS_BY_ID: `${apiUrl}/api/hotel`,
ADD_HOTELS: `${apiUrl}/api/hotel/register`,
CREATE_NEW_RIDE_BY_HOTEL:`${apiUrl}/api/hotel/send/request`,
GET_UPCOMINGTRIP_LISTS_HOTEL: `${apiUrl}/api/hotel/upcoming_rides`,
GET_MYTRIP_LISTS_HOTEL: `${apiUrl}/api/hotel/my_trips`,
CANCEL_UPCOMINGRIDE_BY_HOTEL: `${apiUrl}/api/hotel/cancel_ride`,

//Triplist
GET_TRIP_LISTS: `${apiUrl}/api/user-trips`,
GET_TRIP_LISTS_CORP: `${apiUrl}/api/user-trips/corp`,
GET_TRIP_LISTS_CORP_DAILY: `${apiUrl}/api/user-trips/corp_daily`,
GET_TRIP_LISTS_CORP_MONTHLY: `${apiUrl}/api/user-trips/corp_monthly`,
GET_TRIP_LISTS_CORP_YEARLY: `${apiUrl}/api/user-trips/corp_yearly`,
GET_FILTERED_TRIP_LISTS: `${apiUrl}/api/user-trips/user-trips-filtered`,
GET_DRIVERS_INFO:`${apiUrl}/api/user-trips/driversinfo`,
GET_RIDES_OF_DRIVER:`${apiUrl}/api/user-trips/rides_of_driver`,

//Wallet 
GET_ALL_USERWALLET:`${apiUrl}/api/wallet/users`,
GET_ALL_USERWALLET_LOGS:`${apiUrl}/api/wallet/userslog`,
ADD_WALLET_AMOUNT:`${apiUrl}/api/wallet/addmoney`,
GET_ALL_DRIVERWALLET:`${apiUrl}/api/wallet/drivers`,
//GET_ALL_DRIVERWALLET_LOGS:`${apiUrl}/api/wallet/driverslog`,

//Notifications
GET_NOTIFICATIONS_LIST:`${apiUrl}/api/notifications`,
GET_USERS_LIST: `${apiUrl}/api/customer/allusers`,
DELETE_MULTIPLE_NOTIFICATIONS:`${apiUrl}/api/notifications`,
SEND_SMS_NOTIFICATIONS:`${apiUrl}/api/notifications/sendsms`,
SEND_MAIL_NOTIFICATIONS:`${apiUrl}/api/notifications/sendmails`,
SEND_PUSH_NOTIFICATIONS:`${apiUrl}/api/notifications/sendpushnotifies`,



};

export const ACTION_TYPES = {
  SHOW_SNACKBAR: "SHOW_SNACKBAR",
  HIDE_SNACKBAR: "HIDE_SNACKBAR",
  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",
  MENU_TOGGLE: "MENU_TOGGLE",
  AUTH: "AUTH",
  PROFILE_SETTINGS: "PROFILE_SETTINGS",
  SITE_LOGO: "SITE_LOGO",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  TIMEZONE:"TIMEZONE",
  LATITUDE: "LATITUDE",
  LONGITUDE: "LONGITUDE",
  PROFILE_DETAILS: "PROFILE_DETAILS"
};
